import { SPLINE_URL } from "@/components/sections/hero/heroShared";
import SplineScaledIframe from "@/components/sections/hero/SplineScaledIframe";

/** Official Spline embed — keep in sync with Spline export panel. */
export default function HeroSplineEmbed({
  src = SPLINE_URL,
  stageClassName = "",
  renderWidth,
  renderHeight,
  scaleMode,
}) {
  return (
    <SplineScaledIframe
      src={src}
      title="DSite 3D hero"
      stageClassName={stageClassName}
      allow="autoplay; fullscreen"
      renderWidth={renderWidth}
      renderHeight={renderHeight}
      scaleMode={scaleMode}
    />
  );
}
